var FieldEntryMessageRMQ = [
  { name: "EntryName", type: "str" },
  { name: "RiderName", type: "str" },
  { name: "EarlyScratch", type: "bool" },
  { name: "FinishPos", type: "int" },
  { name: "Weight", type: "int" },
  { name: "IsPTF", type: "bool" },
  { name: "TrainerName", type: "str" },
  { name: "OwnerName", type: "str" },
  { name: "Breeders", type: "str" },
  { name: "Pedigrees", type: "str" },
  { name: "ML", type: "int" },
];

export default FieldEntryMessageRMQ;
